import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Affiche toutes les images du restaurant (bannière, logo, slide, card, restaurant, galerie)
 * à partir de profile (banner_image_url, logo_url, slide_image_url, card_image_url,
 * restaurant_image_url, images_by_type).
 */
const RestaurantImagesSection = ({ restaurant, getImageUrl = (url) => url || '' }) => {
  const { t } = useTranslation();
  const imageList = useMemo(() => {
    if (!restaurant) return [];
    const byType = restaurant.images_by_type || {};
    const order = ['banner', 'logo', 'slide', 'card', 'restaurant', 'gallery'];
    const list = [];
    order.forEach((type) => {
      const arr = byType[type];
      if (Array.isArray(arr)) {
        arr.forEach((item) => {
          if (item?.image_url) list.push({ url: item.image_url });
        });
      }
    });
    if (list.length === 0) {
      [restaurant.banner_image, restaurant.logo_image, restaurant.slide_image_url, restaurant.card_image_url, restaurant.restaurant_image_url]
        .filter(Boolean)
        .forEach((url) => list.push({ url }));
    }
    return list;
  }, [restaurant]);

  if (imageList.length === 0) return null;

  return (
    <div>
      <h3 style={{ margin: '0 0 14px', fontFamily: 'Fraunces, Georgia, serif', fontWeight: 600, fontSize: '19px' }}>
        {t('restaurant.photos')}
      </h3>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
        {imageList.map(({ url }, index) => (
          <div
            key={`img-${index}-${url}`}
            className="aspect-square overflow-hidden bg-namke-cream"
            style={{ borderRadius: '18px' }}
          >
            <img
              src={getImageUrl(url)}
              alt={t('restaurant.photoAlt', { number: index + 1 })}
              className="w-full h-full object-cover"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default RestaurantImagesSection;
